import { Customer } from "../../../../data/entities";
import ContactPersonForm from "./ContactPerson";
import ContactList from "./ContactList";
import DeliveryAddressList from "./DeliveryAddressList";
import { PageContentWrapper } from "../../../../shared/styled/PageContentStyle";
interface FormContainerProps {
    validated: boolean;
    mergeCustomer: Function;
    customerData: Customer;
}

const FormContainer = ({
    validated,
    mergeCustomer,
    customerData,
}: FormContainerProps) => {
    const contact_list = customerData.contact_list || [];
    const delivery_addresses = customerData.delivery_addresses || [];

    let nextId = contact_list.length > 0
        ? Math.max(...contact_list.map((contact: any) => contact.id))
        : 0;

    const handleChangePersonContact = (updatePersonContact: any) => {
        const updatedContactPerson = {
            ...customerData,
            name: updatePersonContact.name,
            phone: updatePersonContact.phone,
            category: updatePersonContact.category,
            email: updatePersonContact.email,
            customer_code: updatePersonContact.customer_code,
            address: updatePersonContact.address,
            tax_id: updatePersonContact.tax_id,
            is_internal: updatePersonContact.is_internal,
            payable_days: updatePersonContact.payable_days,
            credit_limit: updatePersonContact.credit_limit,
            sales_staff: updatePersonContact.sales_staff,
            contact_list: contact_list,
            delivery_addresses,
        };

        mergeCustomer(updatedContactPerson);
    };

    const handleChangeContactList = (updateContact: any) => {
        const updateContactList = contact_list.map((contact: any) => {
            if (contact.id === updateContact.id) {
                return {
                    ...contact,
                    contact: {
                        ...contact.contact,
                        is_default: updateContact.is_default,
                        name: updateContact.name,
                        phone: updateContact.phone,
                        email: updateContact.email,
                        position: updateContact.position,
                    },
                };
            } else if (updateContact.is_default) {
                return {
                    ...contact,
                    contact: {
                        ...contact.contact,
                        is_default: false,
                    },
                };
            }
            return contact;
        });
        mergeCustomer({ contact_list: updateContactList });
    };

    const handleAddContact = () => {
        const addContactList = [
            ...contact_list,
            {
                id: ++nextId,
                contact: {
                    is_default: false,
                    name: "",
                    phone: "",
                    email: "",
                    position: "",
                },
            },
        ];
        mergeCustomer({ contact_list: addContactList });
    };

    const handleDeleteContact = (contactId: number) => {
        const deleteContact = contact_list.filter(
            (contact: any) => contact.id !== contactId
        );
        mergeCustomer({ contact_list: deleteContact });
    };

    return (
        <PageContentWrapper>
            <ContactPersonForm
                validated={validated}
                customerData={customerData}
                handleChangePersonContact={handleChangePersonContact}
            />
            <DeliveryAddressList
                addresses={delivery_addresses}
                validated={validated}
                onChange={(addresses) =>
                    mergeCustomer({ delivery_addresses: addresses })
                }
            />
            <ContactList
                validated={validated}
                contactList={contact_list}
                onChangeContactList={handleChangeContactList}
                onAddContact={handleAddContact}
                onDeleteContact={handleDeleteContact}
            />
        </PageContentWrapper>
    );
};

export default FormContainer;
